module.exports = __webpack_public_path__ + "img/google-play-blue.0c8ffb29.png";